//Dependency External
import { ReactNode } from 'react';
import { LanguageTranslate } from '..//Infraestructure/LanguageTranslate';
import { Breadcrumb, Navbar, Offcanvas } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

// Imagenes
import imgLogo from '../../../assets/img/IconosAppGIAMovil/logo.svg';
import imgUser from '../../../assets/img/user.png';
import imgNoSignal from '../../../assets/img/noSignal.png';

//Style
import './ObjectHeader.scss';
import { EntityDataUsuario } from '../Domain/EntityDataUsuario';

interface ViewProps {
    auth: boolean;
    user: EntityDataUsuario;

    iconMenu: boolean;
    onHideIconMenu: Function;
    onShowIconMenu: Function;

    online: boolean;
    countProcess: number;
    pageTitle?: string;
    pageSubtitle?: string;
    headerExtra?: ReactNode;
    breadcrumbList?: Array<{ text: string; navigate: boolean; path: string }>;

    onClickHome?: Function;
    onClickHelp?: Function;
    onClickReport?: Function;
    onClickProfile?: Function;
    onClickVariable?: Function;
    onClickLogout?: Function;
    showSaludo: boolean;
};

export const ObjectHeader = (props: ViewProps) => {
    const languageTranslate = LanguageTranslate();
    const navigate = useNavigate();
    const isInternalPage = props.showSaludo && !!props.pageTitle;

    return (
        <div className='ObjectHeader'>
            <Navbar bg="primary" className={isInternalPage ? 'navbar-module' : ''}>
                <div className="container-fluid">
                    <div className="navbar-title">
                        {
                            isInternalPage
                                ? <>
                                    <h6 className="mb-0 fw-bold text-white text-truncate text-center" style={{ fontSize: '16px', paddingTop: '10px' }}>
                                        {languageTranslate.nombreProyectoCorto}
                                    </h6>
                                    <div className='header-internal-block'>
                                        <Breadcrumb className='header-breadcrumb mb-0' style={{ paddingTop: '14px' }}>
                                            <Breadcrumb.Item className='header-breadcrumb-item' href="#" onClick={() => navigate(`/${process.env.REACT_APP_ROUTE_PATH_MAIN}/${process.env.REACT_APP_ROUTE_PATH_MAIN_HOME}`, { replace: true })}>{languageTranslate.textoNavbarInicio.toLocaleUpperCase()}</Breadcrumb.Item>
                                            {
                                                (props.breadcrumbList || []).map(row => (
                                                    <Breadcrumb.Item key={row.text} className='header-breadcrumb-item' href="#" onClick={() => row.navigate ? navigate(row.path, { replace: true }) : null} active={!row.navigate}>{row.text}</Breadcrumb.Item>
                                                ))
                                            }
                                        </Breadcrumb>
                                        <h6 className='text-white mb-0' style={{ fontWeight: 300, fontSize: 14 }}>{props.pageSubtitle || languageTranslate.textoBienvenido}</h6>
                                        <h3 className='text-white fw-bold mb-0'>{props.pageTitle}</h3>
                                        { props.headerExtra ? <div className='header-extra'>{props.headerExtra}</div> : null }
                                    </div>
                                </>
                                : <div className='text-center'>
                                    <img className='img-thumbnail' style={{ borderRadius: '50%', padding: 10 }} src={imgLogo} alt="Logo" width={70} />
                                    <h6 className="mb-0 fw-bold text-white text-truncate pt-2" style={{ fontSize: '11px' }}>
                                        {languageTranslate.nombreProyecto}
                                    </h6>
                                    <h3 className='text-white' style={{ paddingTop: '10px' }}>{languageTranslate.moduloMain.textoBienvenida}</h3>
                                    <h6 className='text-white'>{`${props.user.Name} ${props.user.LastNameFather} ${props.user.LastNameMother}`.trim()}</h6>
                                </div>
                        }
                    </div>
                </div>

                <div className="navbar-offline" hidden={props.online}>
                    <div>
                        <img className='imgNoSignal' src={imgNoSignal} alt="noSignal" width={20} />
                        <label className='count-offline'>{props.countProcess}</label>
                    </div>
                </div>

                <div className='navbar-profile' onClick={() => props.onShowIconMenu()}>
                    <div className='profile d-flex align-items-center' style={{ cursor: 'pointer' }} >
                        <i className="fa-solid fa-bars text-white userIcon" />
                    </div>
                </div>

                <Offcanvas show={props.iconMenu} onHide={props.onHideIconMenu} className='SidebarMenu'>
                    <Offcanvas.Header className='sidebar-header'>
                        <div className='sidebar-brand'>
                            <img className='sidebar-brand-logo' src={imgLogo} alt="logo" />
                            <span className='sidebar-brand-name'>{process.env.REACT_APP_TITLE}</span>
                        </div>

                        <div className='sidebar-profile-card' onClick={() => !!props.onClickProfile ? props.onClickProfile() : undefined}>
                            <img title={props.user?.username} src={imgUser} alt="userIcon" className="sidebar-profile-avatar" />
                            <div className='sidebar-profile-info'>
                                <span className='sidebar-profile-name'>{`${props.user.Name} ${props.user.LastNameFather} ${props.user.LastNameMother}`.trim()}</span>
                                <span className='sidebar-profile-role'>{`${ props.user?.Rol?.Name || '-' }`}</span>
                            </div>
                            <i className='fa-solid fa-chevron-right sidebar-profile-chevron' />
                        </div>
                    </Offcanvas.Header>
                    <Offcanvas.Body className='sidebar-body'>
                        <div className='sidebar-menu-group'>
                            <div className='sidebar-menu-item' onClick={() => !!props.onClickHome ? props.onClickHome() : undefined}>
                                <span className='sidebar-menu-icon icon-blue'><i className='fa-solid fa-home' /></span>
                                <span className='sidebar-menu-label'>{languageTranslate.moduloMain.textoInicio}</span>
                            </div>
                            <div className='sidebar-menu-item' onClick={() => !!props.onClickHelp ? props.onClickHelp() : undefined}>
                                <span className='sidebar-menu-icon icon-teal'><i className='fa-regular fa-circle-question' /></span>
                                <span className='sidebar-menu-label'>{languageTranslate.moduloMain.textoAyuda}</span>
                            </div>
                            <div className='sidebar-menu-item' onClick={() => !!props.onClickReport ? props.onClickReport() : undefined}>
                                <span className='sidebar-menu-icon icon-purple'><i className='fa-solid fa-bug' /></span>
                                <span className='sidebar-menu-label'>{languageTranslate.moduloMain.textoReporte}</span>
                            </div>
                            <div className='sidebar-menu-item' onClick={() => !!props.onClickVariable ? props.onClickVariable() : undefined}>
                                <span className='sidebar-menu-icon icon-orange'><i className='fa-solid fa-table' /></span>
                                <span className='sidebar-menu-label'>{languageTranslate.moduloMain.textoRefrescarDatos}</span>
                            </div>
                        </div>

                        <div className='sidebar-menu-item sidebar-menu-item--danger' onClick={() => !!props.onClickLogout ? props.onClickLogout() : undefined}>
                            <span className='sidebar-menu-icon icon-danger'><i className='fa fa-power-off' /></span>
                            <span className='sidebar-menu-label'>{languageTranslate.textoCerrarSesion}</span>
                        </div>

                        <span className='sidebar-version'>
                            v.{process.env.REACT_APP_VERSION_SYSTEM}
                        </span>
                    </Offcanvas.Body>
                </Offcanvas>

            </Navbar>
        </div>
    )
}